import { render } from "./Enhance-product-page.vue?vue&type=template&id=533227fa&scoped=true"
import script from "./Enhance-product-page.vue?vue&type=script&lang=js"
export * from "./Enhance-product-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=533227fa&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533227fa"]])

export default __exports__